import { useEffect, useState } from "react";
import { Search, ShieldX, CheckCircle2 } from "lucide-react";
import { Input } from "../components/ui/input";
import { api, errMsg } from "../lib/api";
import { useI18n } from "../lib/i18n";
import { PageHeader } from "../components/Card";
import { DataTable, FilterSelect, Pager } from "../components/DataTable";

const Outcome = ({ v }) => {
  const { tv } = useI18n();
  const denied = v === "denied";
  const Icon = denied ? ShieldX : CheckCircle2;
  return (
    <span className={`inline-flex items-center gap-1 rounded-lg border px-2 py-0.5 text-xs font-semibold ${denied ? "border-rose-300 bg-rose-100 text-rose-900" : "border-emerald-300 bg-emerald-50 text-emerald-900"}`}>
      <Icon className="h-3.5 w-3.5" aria-hidden="true" />{tv(v)}
    </span>
  );
};

export default function AuditLog() {
  const { t } = useI18n();
  const [q, setQ] = useState("");
  const [outcome, setOutcome] = useState("");
  const [page, setPage] = useState(1);
  const [data, setData] = useState({ items: [], total: 0 });
  const [err, setErr] = useState("");
  useEffect(() => {
    const h = setTimeout(() => api.get("/audit", { params: { q, outcome, page, limit: 50 } }).then((r) => setData(r.data)).catch((e) => setErr(errMsg(e))), 250);
    return () => clearTimeout(h);
  }, [q, outcome, page]);

  const cols = [
    { key: "timestamp", label: t("time"), render: (r) => <span className="whitespace-nowrap font-mono text-xs" dir="ltr">{new Date(r.timestamp).toLocaleString()}</span> },
    { key: "actor", label: t("actor"), render: (r) => <bdi className="text-xs">{r.actor}</bdi> },
    { key: "action", label: t("action"), render: (r) => <span className="font-mono text-xs">{r.action}</span> },
    { key: "entity", label: t("entity"), render: (r) => <span className="text-xs">{r.entity}{r.entity_id ? ` · ${r.entity_id}` : ""}</span> },
    { key: "outcome", label: t("outcome"), render: (r) => <Outcome v={r.outcome} /> },
  ];

  if (err) return <p data-testid="audit-error" className="text-rose-700">{err}</p>;
  return (
    <div>
      <PageHeader title={t("nav_audit")} sub={`${t("total")}: ${data.total}`}>
        <FilterSelect value={outcome} onChange={(v) => { setPage(1); setOutcome(v); }} options={["success", "denied"]} placeholder={t("outcome")} testId="audit-outcome-filter" />
      </PageHeader>
      <div className="relative mb-4 max-w-md">
        <Search className="absolute start-3 top-3 h-4 w-4 text-slate-400" />
        <Input data-testid="audit-search-input" value={q} onChange={(e) => { setPage(1); setQ(e.target.value); }} placeholder={t("search")} className="h-10 rounded-xl ps-9" />
      </div>
      <DataTable cols={cols} rows={data.items} testId="audit-table" />
      <Pager page={page} total={data.total} limit={50} onPage={setPage} />
    </div>
  );
}
